import React, { useState } from 'react';
import SaveMxRecordModal from './SaveMxRecordModal';

export default function SaveMxRecordButton() {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <a href="#" onClick={() => setShowModal(true)}>
        Save MxRecords of Email / Email Domains in CSV
      </a>
      <SaveMxRecordModal
        isVisible={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
}
